<template>
    <div class="edit-house-page">
        <Breadcrumb />
        <edit-house-comp :class="{'fixed': listIsFixed}"></edit-house-comp>
    </div>
</template>
<script>
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import EditHouseComp from '@/components/landlord/houseStatus/houseManagement/addHouse/EditHouseComp.vue';

export default {
    name: 'editHouse',
    data () {
        return {
            listIsFixed: false
        }
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('edit-add-house-head')[0].style.zIndex = '8'
            }else{
                document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('edit-add-house-head')[0].style.zIndex = '8'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
    },
    components: {
        Breadcrumb,
        EditHouseComp
    }
}
</script>
<style lang="scss" scoped>
    .edit-house-page{
        position: relative;
        margin-top: 82px;
        
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/HouseManagementPages/EditHouse.vue